<template>
<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle"><b>PKR {{unpaidAmount}}</b></h5>
                {{ formattedDate(oldestDueDate) }}
                <button role="button" class="border-0 p-0 bg-transparent" @click="closeModal">
                    <svg width="33" height="20" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.265 12.7989C12.5882 9.12215 9.10843 5.63707 5.62069 2.15997C5.09087 1.63016 4.60092 0.826188 3.97271 0.687628C3.07565 0.487784 1.8885 0.487506 1.15129 0.937172C0.0707674 1.59171 -0.0194419 2.83208 0.832571 3.87569C1.54081 4.7436 2.37412 5.51304 3.16752 6.30644C6.37571 9.52527 9.59189 12.7361 12.9625 16.1067C11.5494 17.5198 10.2827 18.7865 9.01334 20.0559C6.45066 22.6185 3.87733 25.1653 1.33594 27.7492C0.0745642 29.0319 0.00566136 30.3042 1.04933 31.3639C2.09299 32.4235 3.39725 32.3972 4.67194 31.1438C8.05427 27.8147 11.3967 24.4404 14.7524 21.0847C15.226 20.611 15.7024 20.1346 16.3437 19.4933C17.4859 20.6355 18.4896 21.6392 19.4933 22.6429C22.2756 25.4251 25.0471 28.2233 27.848 30.9869C29.2643 32.382 30.4914 32.4807 31.5719 31.3684C32.6443 30.264 32.5136 29.0848 31.0892 27.6444C27.8331 24.3617 24.5557 21.1003 21.2862 17.8308C20.807 17.3516 20.3304 16.875 19.7208 16.2654C20.2663 15.6613 20.6894 15.153 21.1577 14.6846C24.4655 11.3662 27.7893 8.06368 31.0891 4.73724C32.4889 3.32683 32.6377 2.08116 31.61 0.97894C30.5157 -0.195159 29.1795 -0.0890008 27.7239 1.356C23.961 5.08692 20.2168 8.84712 16.265 12.7989Z" fill="black" />
                    </svg>
                </button>
            </div>
            <div class="modal-body">
                <div class="container">
                    <div v-if="paymentMode === 'IBFT'">
                        <input type="file" multiple @change="handleFileUpload" />
                    </div>
                </div>
                <div>
                    <table class="table table-striped" v-if="selectedItems.length > 0">
                        <thead>
                            <tr>
                                <th>Item Name</th>
                                <th>Amount</th>
                                <th>Course Amount</th>
                                <th>Remaining Amount</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in selectedItems" :key="index">
                                <td>{{ item.item_name }}</td>
                                <td>
                                    <input v-model="item.paymentAmountInput" type="text" :placeholder="'Enter amount for ' + item.item_name" class="w-50 input-field-StdInfo" @input="amountInputValidate(item)" />
                                </td>
                                <td>{{ item.amount }}</td>
                                <td>{{ getModifiedAmount(item) }}</td>
                                <td>
                                    <div class="ms-2 text-danger">
                                        <span><i class="fa-solid fa-trash" style="cursor: pointer;" @click="removeSelectedItem(index)"></i></span>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>

                    <div v-else class="text-center text-danger">No Items Found</div>
                    <div v-if="amountExceed" class="d-flex align-items-center justify-content-center gap-3 p-3 font-500">
                        <p class="text-danger text-center">Amount Exceeds!</p>
                    </div>
                </div>
                <div>
                    <v-select v-model="selectedItem" :options="filteredItems" label="item_name" :multiple="false" placeholder="Select Item (Required)" required></v-select>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" @click="closeModal">Close</button>
                <button type="button" class="btn btn-outline-primary" :disabled="isPaymentButtonDisabled || amountExceed || fileLength <= 0 " @click="payment()">
                    <b-spinner v-if="loading" small> </b-spinner>Payment
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import * as invoiceHelper from '../../store/invoiceHelper';
import * as LmsApiHelper from '../../store/LmsApiHelper';
export default {
    name: 'AttachmentModal',
    props: {
        unpaidAmount: [String, Number],
        oldestDueDate: String,
        invoiceId: String,
        customerName: String,
        invoice: Object,
        invoicePaymentDetail: Array,
        paymentMode: String,
        userId: String
    },
    data() {
        return {
            selectedOption: null,
            items: ["Cash", "IBFT"],
            rows: [{
                mode: null,
                amount: null
            }],
            loading: false,
            selectedItem: null,
            selectedItems: [],
            amountExceed: false,
            fileData: []

        };
    },
    methods: {
        closeModal() {
            this.rows = [{
                mode: null,
                amount: null
            }];
            $('#exampleModalCenter').modal('hide');
            this.$emit("getData");
            this.selectedItems = [];
        },
        async payment() {
    try {
        this.loading = true;

        for (const selectedItem of this.selectedItems) {
            try {
                const item_pv_id = await invoiceHelper.getItemByItemName(selectedItem.item_id);
                const response = await LmsApiHelper.courseAccess(this.userId, item_pv_id.custom_product_variant_id, this.oldestDueDate);
                if(response === 401){
                    this.$toasted.error("You are already logged in.", {
            theme: "outline",
            duration: 3000,
            icon: "exclamation-triangle",
            position: "bottom-center",
        });
                    localStorage.clear();
                    this.$router.push('/login');
                    return;
                }
            } catch (error) {
                console.error(`Error in courseAccess for item ${selectedItem.item_id}:`, error);
                throw new Error("courseAccess API failed. Aborting payment process.");
            }
        }

        const referencesAmount = this.rows.map(payment => ({
            "reference_doctype": "Sales Invoice",
            reference_name: this.invoiceId,
            allocated_amount: parseFloat(this.unpaidAmount)
        }));
        const paymentData = {
            "doctype": "Payment Entry",
            "payment_type": "Receive",
            posting_date: new Date().toISOString().split('T')[0],
            mode_of_payment: this.paymentMode,
            received_amount: parseFloat(this.unpaidAmount),
            paid_amount: parseFloat(this.unpaidAmount),
            "party_type": "Customer",
            party: this.customerName,
            "company": "Learn360",
            remarks: `Payment for Sales Invoice ${this.invoiceId}`,
            "target_exchange_rate": 1,
            "source_exchange_rate": 1,
            references: referencesAmount,
            paid_to: this.paymentMode + "- TD",
            "paid_to_account_currency": "PKR"
        };

        const createPayment = await invoiceHelper.createPayment(paymentData);
        const paymentName = createPayment.data.name;

        if (createPayment && createPayment.data != null) {
            for (const selectedItem of this.selectedItems) {
                const paymentDetail = {
                    paymentid: paymentName,
                    itemid: selectedItem.item_id,
                    amount: selectedItem.paymentAmountInput,
                    invoiceid: this.invoiceId,
                    "status": "Payment"
                };
                await invoiceHelper.createPaymentDetail(paymentDetail);
            }

            for (let i = 0; i < this.fileData.length; i++) {
                const fileResponse = await this.uploadFile(this.fileData[i]);
                await this.linkFile(paymentName, fileResponse.file_url);
            }

            const message = "Payment Successful";
            this.$toasted.success(`${message}!`, {
                theme: "outline",
                position: "bottom-center",
                duration: 3000,
            });

        } else {
            this.$toasted.error("Invalid Data", {
                theme: "outline",
                duration: 3000,
                icon: "exclamation-triangle",
                position: "bottom-center",
            });
        }

    } catch (error) {
        console.error(error);
        this.$toasted.error("Payment process failed. Please try again.", {
            theme: "outline",
            duration: 3000,
            icon: "exclamation-triangle",
            position: "bottom-center",
        });
    } finally {
        this.loading = false;
        await this.closeModal();
    }
},
        async uploadFile(fileData) {
            try {
                const uploadUrl = `${this.erp_api_url}api/method/upload_file`;
                let formData = new FormData();
                formData.append('file', fileData);
                formData.append('is_private', '0');

                const response = await fetch(uploadUrl, {
                    method: 'POST',
                    headers: {
                        'Authorization': `${this.authorization_token}`,
                    },
                    body: formData,
                });
                const file = await response.json();
                return file.message;
            } catch (error) {
                console.error("Error Uploading Files");
            }
        },
        async linkFile(paymentId, fileUrl) {
            try {
                const linkData = {
                    "attached_to_doctype": "Payment Entry",
                    attached_to_name: paymentId,
                    file_url: fileUrl
                };
                const response = await fetch(`${this.erp_api_url}api/resource/File`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `${this.authorization_token}`
                    },
                    body: JSON.stringify(linkData)
                })
            } catch (error) {
                console.error("Error Linking File.", error);
            }
        },
        getAmountByItemId(itemId) {
            const matchingDetails = this.invoicePaymentDetail.filter(detail => detail.itemid === itemId);
            if (matchingDetails.length > 0) {
                const totalAmount = matchingDetails.reduce((sum, item) => sum + parseFloat(item.amount), 0);
                return totalAmount;
            } else {
                return 0;
            }
        },
        getModifiedAmount(item) {
            const remainingAmount = item.amount - this.getAmountByItemId(item.item_id);
            return remainingAmount;
        },
        amountInputValidate(item) {
            const inputAmount = parseFloat(item.paymentAmountInput);
            const modifiedAmount = this.getModifiedAmount(item);

            if (inputAmount > modifiedAmount) {
                this.amountExceed = true;
            } else {
                this.amountExceed = false;
            }
        },
        removeSelectedItem(index) {
            if (index > -1) {
                this.selectedItems.splice(index, 1);
            }
        },
        courseStatus(itemid) {
            const matchingItems = this.invoicePaymentDetail.filter(item => item.itemid === itemid);
            const nonPaymentItems = matchingItems.filter(item => item.status !== "Payment");
            if (nonPaymentItems.length > 0) {
                return nonPaymentItems[0].status;
            } else {
                return null;
            }
        },
        formattedDate(dateString) {
            const options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            const formattedDate = new Date(dateString).toLocaleDateString('en-US', options);
            return formattedDate;
        },
        async handleFileUpload(event) {
            const files = event.target.files;
            this.fileData = files;
        }
    },
    watch: {
        selectedItem(newItem, oldItem) {
            if (newItem && !this.selectedItems.some(item => item.item_name === newItem.item_name)) {
                this.selectedItems.push({
                    item_name: newItem.item_name,
                    amount: newItem.rate,
                    item_id: newItem.item_code,
                    paymentAmountInput: 0
                });
                this.selectedItem = null;
            }
        },

    },
    computed: {
        ...mapState(["erp_api_url","authorization_token"]),
        isPaymentButtonDisabled() {
            const totalAmount = this.selectedItems.reduce((acc, row) => acc + (row.paymentAmountInput ? parseFloat(row.paymentAmountInput) : 0), 0);
            return this.selectedItems.some(row => !row.paymentAmountInput) || totalAmount !== parseFloat(this.unpaidAmount);
        },
        filteredItems() {
            if (this.invoice.items && this.invoice.items.length) {
                return this.invoice.items.filter(item => item.is_free_item === 0 && this.courseStatus(item.item_code) !== 'Freeze' && this.courseStatus(item.item_code) !== 'TransferOut');
            }
        },
        fileLength() {
            if (this.paymentMode === 'IBFT') {
                return this.fileData.length;
            }
            return;
        }
    },
}
</script>

<style scoped>
.input-field-StdInfo {
    padding: 2px 8px;
    border-radius: 7px;
    margin-bottom: 5px;
    border: 1px solid #dcd8d8;
}
</style>
